import React from 'react';
import './waiting.css';

const waiting = (props) => {
    return (
        <div className="waitingComponent lucky_waiting" style={{height: props.height}}>
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>        
    );
}

export default waiting;